// export const getUOMList = [
//   "BAG-BAG",
//   "BGS-BAGS",
//   "BKL-BUCKLES",
//   "BOU-BOU",
//   "BOX-BOX",
//   "BTL-BOTTLES",
//   "BUN-BUNCHES",
//   "CBM-CUBIC METER",
//   "CCM-CUBIC CENTIMETER",
//   "CIN-CUBIC INCHES",
//   "CMS-CENTIMETER",
//   "CQM-CUBIC METERS",
//   "CTN-CARTON",
//   "DOZ-DOZEN",
//   "DRM-DRUM",
//   "FTS-FEET",
//   "GGR-GREAT GROSS",
//   "GMS-GRAMS",
//   "GRS-GROSS",
//   "GYD-GROSS YARDS",
//   "HKS-HANKS",
//   "INC-INCHES",
//   "KGS-Kilograms",
//   "KLR-KILOLITER",
//   "KME-KILOMETERS",
//   "LBS-POUNDS",
//   "LOT-LOTS",
//   "LTR-LITERS",
//   "MGS-MILLI GRAMS",
//   "MTR-METER",
//   "MTS-METRIC TON",
//   "NOS-Numbers",
//   "ODD-ODDS",
//   "PAC-PACKS",
//   "PCS-PIECES",
//   "PRS-PAIRS",
//   "QTL-QUINTAL",
//   "ROL-ROLLS",
//   "SDM-DECAMETER SQUARE",
//   "SET-SETS",
//   "SHT-SHEETS",
//   "SQF-SQUARE FEET",
//   "SQI-SQUARE INCHES",
//   "SQM-SQUARE METER",
//   "SQY-SQUARE YARDS",
//   "TBS-TABLETS",
//   "THD-THOUSANDS",
//   "TOL-TOLA",
//   "TON-GREAT BRITAIN TON",
//   "TUB-TUBES",
//   "UGS-US GALLONS",
//   "UNT-UNITS",
//   "VLS-Vials",
//   "YDS-YARDS",
//   "MLT-MILLILITRE",
//   "OTH-OTHERS",
// ];

export const stockItemList = [
  "FINISH",
  "RAW MAT",
  "TRADING",
  "SEMI FINISH",
  "OTHER"
];

export const itemStatus = [
  "OPEN",
  "CLOSED"
];


export const registrationType = [
  "Regular",
  "Composition",
  "Consumer",
  "Unregistered"
];

export const partyType = [
  "Not Applicable",
  "Deemed Export",
  "SEZ"
];

export const invoiceType = [
  "Input Goods",
  "Input Services",
  "Capital Goods"
];

export const MSMECategory = [
  "MICRO",
  "SMALL",
  "MEDIUM"
];

export const MSMEType = [
  "Manufacture",
  "Trader",
];

export const beamTypeList = [
  "Primary",
  "Secondary",
  "2nd Secondary"
];

export const branchList = [
  "Branch 1",
  "Branch 2",
  "Branch 3"
];

export const designationList = [
  "LOOM MASTER",
  "RAPIER MASTER"
];

export const rateOnList = [
  "D",
  "M"
]

export const billStatus = [
  "Open",
  "Close"
]

export const ExportType = {
  WOPAY: 'WOPAY',
  WPAY: 'WPAY',
}
export const exportTypes = [
  ExportType.WOPAY,
  ExportType.WPAY,
];

export const ShortExcessType = {
  SHORT: 'SHORT',
  EXCESS: 'EXCESS',
  SHORTAGE: 'SHORTAGE',
};

export const BookTypes = {
  Sales: 'Sales',
  Purchase: 'Purchase',
  Bank: 'Bank',
  Cash: 'Cash',
}

export const BookCodePrev = {
  Sales: 'Sal',
  Purchase: 'Pur',
  Bank: 'Bnk',
  Cash: 'Csh',
}

export const billType = [
  "Register Dealer",
  "UnRegister Dealer",
  "Non ITC",
  "Ineligible ITC"
]

export const bookTypeCode = [
  { type: BookTypes.Sales, code: BookCodePrev.Sales },
  { type: BookTypes.Purchase, code: BookCodePrev.Purchase },
  { type: BookTypes.Bank, code: BookCodePrev.Bank },
  { type: BookTypes.Cash, code: BookCodePrev.Cash },
];

export const taxType = [
  "TAX",
  "RETAIL",
  "NO VAT"
];

export const intCalculation = ["Yearly", "Monthly"];

export const Entry_Type = {
  SALES_BILL: 'SALES_BILL',
  PURCHASE_BILL: 'PURCHASE_BILL',
  GENERAL_PURCHASE_BILL: 'GENERAL_PURCHASE_BILL',
  BANK_RECEIPT_RETURN: 'BANK_RECEIPT_RETURN',
  BANK_PAYMENT_RETURN: 'BANK_PAYMENT_RETURN',
  DEBIT_NOTE_BILL_BASE: 'DEBIT_NOTE_BILL_BASE',
  CREDIT_NOTE_BILL_BASE: 'CREDIT_NOTE_BILL_BASE',
  DRAFT_DEBIT_NOTE_BILL_BASE: 'DRAFT_DEBIT_NOTE_BILL_BASE',
  DRAFT_CREDIT_NOTE_BILL_BASE: 'DRAFT_CREDIT_NOTE_BILL_BASE',
};

export const Form_Type = {
  BANK_RECEIPT: 'BANK_RECEIPT',
  CASH_RECEIPT: 'CASH_RECEIPT',
  CASH_PAYMENT: 'CASH_PAYMENT',
  BANK_PAYMENT: 'BANK_PAYMENT',
  SALES_RETURN: 'SALES_RETURN',
  PURCHASE_RETURN: 'PURCHASE_RETURN',
  GENERAL_PUR_RETURN: 'GENERAL_PUR_RETURN',
  CREDIT_NOTE: 'CREDIT_NOTE',
  DEBIT_NOTE: 'DEBIT_NOTE',
  JOURNAL_VOUCHER: 'JOURNAL_VOUCHER',
  DEBIT_NOTE_BILL_BASE_RETURN: 'DEBIT_NOTE_BILL_BASE_RETURN',
  CREDIT_NOTE_BILL_BASE_RETURN: 'CREDIT_NOTE_BILL_BASE_RETURN',
}

export const Trans_Type = {
    PURCHASE_BILL: 'PURCHASE_BILL',
    PURCHASE_RETURN: 'PURCHASE_RETURN',
    SALES_BILL: 'SALES_BILL',
    SALES_RETURN: 'SALES_RETURN',
    GENERAL_PURCHASE_BILL: 'GENERAL_PURCHASE_BILL',
    GENERAL_PURCHASE_RETURN: 'GENERAL_PURCHASE_RETURN',
    DEBIT_NOTE: 'DEBIT_NOTE',
    CREDIT_NOTE: 'CREDIT_NOTE',
    DEBIT_NOTE_BILL_BASE: 'DEBIT_NOTE_BILL_BASE',
    CREDIT_NOTE_BILL_BASE: 'CREDIT_NOTE_BILL_BASE',
    BANK_RECEIPT: 'BANK_RECEIPT',
    BANK_RECEIPT_RETURN: 'BANK_RECEIPT_RETURN',
    BANK_PAYMENT: 'BANK_PAYMENT',
    BANK_PAYMENT_RETURN: 'BANK_PAYMENT_RETURN',
    CASH_RECEIPT: 'CASH_RECEIPT',
    CASH_PAYMENT: 'CASH_PAYMENT',
    JOURNAL_VOUCHER: 'JOURNAL_VOUCHER',
    JOURNAL_VOUCHER_MULTY: 'JOURNAL_VOUCHER_MULTY',
    DEBIT_NOTE_BILL_BASE_RETURN: 'DEBIT_NOTE_BILL_BASE_RETURN',
    CREDIT_NOTE_BILL_BASE_RETURN: 'CREDIT_NOTE_BILL_BASE_RETURN',
}

export const Intrest_Adj_Form_Type = {
  DEBIT_NOTE_BILL_BASE: 'DEBIT_NOTE_BILL_BASE',
  CREDIT_NOTE_BILL_BASE: 'CREDIT_NOTE_BILL_BASE',
  DRAFT_DEBIT_NOTE_BILL_BASE: 'DRAFT_DEBIT_NOTE_BILL_BASE',
  DRAFT_CREDIT_NOTE_BILL_BASE: 'DRAFT_CREDIT_NOTE_BILL_BASE',
}

export const Intrest_Adj_Entry_Type = {
  BANK_RECEIPT: 'BANK_RECEIPT',
  BANK_PAYMENT: 'BANK_PAYMENT',
}

export const Effect_Type = {
  Expence: 'Expense',
  Income: 'Income',
  Assets: 'Assets',
  Liabilities: 'Liabilities',
  Debit: 'Debit',
  Credit: 'Credit',
}

export const Effect_On = {
  Balance_Sheet: 'Balance Sheet',
  Trading_Account: 'Trading Account',
  Profit_And_Loss: 'Profit And Loss',
}

export const REPORTS = {
  BillNoWise: 'billNoWise',
  ItemWiseCheeseWise: 'itemWiseCheeseWise',
  PartyWise: 'partyWise',
  PartyWiseTypeWise: 'partyWiseTypeWise',
  PartyGroupWiseTypeWise: 'partyGroupWiseTypeWise',
  BrokerWise: 'brokerWise',
  BrokerWiseTypeWise: 'brokerWiseTypeWise',
  CityWiseTypeWise: 'cityWiseTypeWise',
  PartyGroupWisePartyWiseTypeWise: 'partyGroupWisePartyWiseTypeWise',
  PartyWiseItemWiseEndsWiseTypeWise: 'partyWiseItemWiseEndsWiseTypeWise',
  BrokerWisePartyGroupWisePartyWiseTypeWise: 'brokerWisePartyGroupWisePartyWiseTypeWise',
  ItemWise: 'itemWise',
  ItemGroupWise: 'itemGroupWise',
  ItemGroupItemWise: 'itemGroupItemWise',
  ItemTypeWise: 'itemTypeWise',
  ItemPartyWise: 'itemPartyWise',
  PartyItemWise: 'partyItemWise',
  MonthWise: 'monthWise',
  PartyAcWise: 'partyAcWise',
  ExpenceAcWise: 'expenceAcWise',
  BrokerMonthExpenceWise: 'brokerMonthExpenceWise',
  DateWise: 'dateWise',
  DueDateWise: 'dueDateWise',
  PartyGroupWise: 'partyGroupWise',
  CityWise: 'cityWise',
  AreaWise: 'areaWise',
  ScheduleAreaWise: 'scheduleAreaWise',
  BrokerAreaWise: "brokerAreaWise",
  SalesPersonPartyGroupWise: "salesPersonPartyGroupWise" ,
  AreaPartyGroupWise: "areaPartyGroupWise",
  AreaPartyGroupPartyBrokerWise: "areaPartyGroupPartyBrokerWise",
  BrokerPartyGroupWise: "brokerPartyGroupWise",
  AllUnadjustment: 'allUnadjustment',
  FullUnadjustment: 'fullUnadjustment',
  PartlyUnadjustment: 'partlyUnadjustment',
  QualityWise: 'qualityWise',
  QualityGradeLotWise: 'qualityGradeLotWise',
  QualityWiseDesignWise: 'qualityWiseDesignWise',
  QualityWiseGradeWise: 'qualityWiseGradeWise',
  QualityWiseCheeseWise: 'qualityWiseCheeseWise',
  DesignWiseQualityWise: 'designWiseQualityWise',
  OrderNoWise: 'orderNoWise',
  LotNoWise: 'lotNoWise',
  PurchaseCompanyWise: 'purchaseCompanyWise',
  SizeWise: 'sizeWise',
  PartyWiseTdsAccountWise: 'partyWiseTdsAccountWise',
  TdsAccountWisePartyWise: 'tdsAccountWisePartyWise',
  MonthWiseTdsAccountWise: 'monthWiseTdsAccountWise',
  TdsSectionWisePartyWise: 'tdsSectionWisePartyWise',
  PartyWiseMonthWise: 'partyWiseMonthWise',
  ChallanNoWise: 'challanNoWise',
  TwistWiseItemWise: 'twistWiseItemWise',
  MonthWiseItemWiseLotWise: 'monthWiseItemWiseLotWise',
  DeliveryPartyWise: 'deliveryPartyWise',
  PartyWiseDeliveryPartyWise: 'partyWiseDeliveryPartyWise',
  VehicleNoWise: 'vehicleNoWise',
  VehicleNoWiseAreaWise: 'vehicleNoWiseAreaWise',
  PartyWiseItemWise: 'partyWiseItemWise',
  PartyWiseQualityWiseDesignWise: 'partyWiseQualityWiseDesignWise',
  ItemWiseDesignWise: 'itemWiseDesignWise',
  DesignWise: 'designWise',
  BeamNoWise: 'beamNoWise',
  EwayBill: 'ewayBill',
  EInvoice: 'eInvoice',
  MachineWise: 'machineWise',
  JobPartyWise: 'jobPartyWise',
  GrayQualityWise: 'grayQualityWise',
  JobPartyWiseGrayQualityWise: 'JobPartyWiseGrayQualityWise',
  EndsWise: 'endsWise',
  ItemWiseEndsWise: 'itemWiseEndsWise',
  MonthWisePartyWise: 'monthWisePartyWise',
  PartyWiseEndsWise: 'partyWiseEndsWise',
  PartyWiseItemWiseEndsWise: 'partyWiseItemWiseEndsWise',
  BeamerNoWiseItemWise: 'beamerNoWiseItemWise',
  MonthWiseItemWise: 'monthWiseItemWise',
  LotWise: 'lotWise',
  LotWiseItemWise: 'lotWiseItemWise',
  AgeWise: 'ageWise',
  BrokerWiseAgeWise: 'brokerWiseAgeWise',
  InwardVehicleNoWise: 'inwardVehicleNoWise',
  TransportWise: 'transportWise',
  SalesPersonWise: 'salesPersonWise',
  LedgerCompareWithOs: 'ledgerCompareWithOs',
  LedgerDifferentWithOs: 'ledgerDifferentWithOs',
  OrderWiseBillWise: 'orderWiseBillWise',
  PartyWiseBrokerWise: 'partyWiseBrokerWise',
  PartyGroupWiseBrokerWise: 'partyGroupWiseBrokerWise',
  PartyWiseItemGroupWise: 'partyWiseItemGroupWise',
  ItemWiseDateWise: 'itemWiseDateWise',
  PartyWisePurchasePartyWise: 'partyWisePurchasePartyWise',
};


export const Report_Master = {
    SALES_BILLS: "Sales Bills",
    SALES_RETURN: "Sales Return",
    DELIVERY_CHALLAN: "Delivery Challan",
    FINISH_DELIVERY_CHALLAN: "Finish Delivery Challan",
    GRAY_ISSUE: "Gray Issue",
    RF_ISSUE: "RF Issue",
    CHEQUE_BANK: "Cheque Bank",
    GRAY_JOB_ISSUE: "Gray Job Issue",
    JOB_ISSUE: "Job Issue",
    YARN_BEAM_ISSUE: "Yarn Beam Issue",
    EMB_DISPATCH: "Emb Dispatch",
    DELIVERY_CHALLAN_TRADING: "Delivery Challan (Trading)",
    PACKING_SLIP: "Packing Slip",
  }
  
export const Report_Master_Types = {
    SALES_BILLS: [
      // { Field_Name: "Invoice_Format1", Label: "Invoice Format 1", Two_Copy: true, Short_Name: "InvFormat1", isChecked: false, SortingOrder: 1 },
      // { Field_Name: "Invoice_Format2", Label: "Invoice Format 2", Two_Copy: true, Short_Name: "InvFormat2", isChecked: false, SortingOrder: 2 },
      { Field_Name: "NOS", Label: "NOS", Short_Name: "NOS", isChecked: false, SortingOrder: 1 },
      { Field_Name: "CUT", Label: "CUT", Short_Name: "CUT", isChecked: false, SortingOrder: 2 },
      { Field_Name: "Quantity", Label: "Quantity", Short_Name: "Qty", isChecked: false, SortingOrder: 3 },
      { Field_Name: "UOM", Label: "Unit", Short_Name: "Unit", isChecked: false, SortingOrder: 4 },
      { Field_Name: "Rate_On", Label: "Rate On", Short_Name: "RateOn", isChecked: false, SortingOrder: 5 },
      { Field_Name: "Net_Rate", Label: "Net Rate", Short_Name: "NetRate", isChecked: false, SortingOrder: 6 },
      { Field_Name: "Item_Discount", Label: "Discount %", Short_Name: "ItemDisc", isChecked: false, SortingOrder: 7 }, 
      { Field_Name: "Item_Discount_Val", Label: "Discount", Short_Name: "ItemDiscVal", isChecked: false, SortingOrder: 8 },
      { Field_Name: "Title", Label: "Title", isInputTypeText: true, value: "", SortingOrder: 9 },
    ],
    SALES_RETURN: [
      // { Field_Name: "Invoice No", Type: "Non-Numeric", Short_Name: "InvNo", isChecked: false },
    ],
    DELIVERY_CHALLAN: [
      { Field_Name: "Taka_No", Label: "Taka/Crtn No", Type: "Non-Numeric", Short_Name: "No", Label_Font_Size: 8, Width: 16.6, Align: 'right', isChecked: false, SortingOrder: 1 },
      { Field_Name: "Ends", Label: "Ends", Type: "Numeric", Short_Name: "End", Label_Font_Size: 8, Width: 15, Align: 'right', isChecked: false, SortingOrder: 2 },
      { Field_Name: "Meter", Label: "Meter", Type: "Numeric", Short_Name: "Mtr", Label_Font_Size: 8, Width: 10, Align: 'right', isChecked: false, SortingOrder: 3 },
      { Field_Name: "Weight", Label: "Weight", Type: "Numeric", Short_Name: "Wgt", Label_Font_Size: 8, Width: 12, Align: 'right', isChecked: false, SortingOrder: 4 },
      { Field_Name: "G_Weight", Label: "G.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "GWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 5 },
      { Field_Name: "T_Weight", Label: "T.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "TWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 6 },
      { Field_Name: "Net_Weight", Label: "Net.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "NtWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 7 },
      { Field_Name: "Cheese", Label: "Cheese", Type: "Numeric", Decimal_Place: 0, Short_Name: "Ch", Label_Font_Size: 8, Width: 11, Align: 'center', isChecked: false, SortingOrder: 8 },
      { Field_Name: "Pallu", Label: "Pallu", Type: "Numeric", Decimal_Place: 3, Short_Name: "Plu", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 9 },
      { Field_Name: "Twist", Label: "Twist", Type: "String", Short_Name: "Twst", Label_Font_Size: 8, Width: 8, Align: 'center', isChecked: false, SortingOrder: 10 },
      { Field_Name: "Quality", Label: "Quality", Type: "String", Short_Name: "Itm", Label_Font_Size: 8, Width: 35, Align: 'left', isChecked: false, SortingOrder: 11 },
      { Field_Name: "Design_Id", Label: "Design", Type: "String", Short_Name: "Dgn", Label_Font_Size: 8, Width: 25, Align: 'left', isChecked: false, SortingOrder: 12 },
      { Field_Name: "Remark", Label: "Remark", Type: "String", Short_Name: "Rmk", Label_Font_Size: 8, Width: 20, Align: 'left', isChecked: false, SortingOrder: 13 },
      { Field_Name: "Pipe_Type", Label: "Pipe Type", Type: "String", Short_Name: "PTyp", Label_Font_Size: 8, Width: 20, Align: 'left', isChecked: false, SortingOrder: 14 },
    ],
    FINISH_DELIVERY_CHALLAN: [
      // { Field_Name: "PO No", Type: "Non-Numeric", Short_Name: "PONo", isChecked: false },
    ],
    GRAY_ISSUE: [
      // { Field_Name: "Taka_No", Type: "Non-Numeric", Short_Name: "No", isChecked: false },
    ],
    RF_ISSUE: [
      // { Field_Name: "Taka_No", Type: "Non-Numeric", Short_Name: "No", isChecked: false },
    ],
    CHEQUE_BANK: [
      { Field_Name: "Payee_Name", Label: "Payee Name", Type: "Non-Numeric", Short_Name: "Name", isChecked: false },
      { Field_Name: "Amount", Label: "Amount", Type: "Numeric", Short_Name: "Amt", isChecked: false },
      { Field_Name: "Date", Label: "Date", Type: "Non-Numeric", Short_Name: "Date", isChecked: false },
      { Field_Name: "AC_Payee_Only", Label: "A/C Payee Only", Type: "Non-Numeric", Short_Name: "A/c Pay", isChecked: false },
      { Field_Name: "Self_Payee", Label: "Self Payee", Type: "Non-Numeric", Short_Name: "Self Pay", isChecked: false },
      { Field_Name: "RTGS_Payee", Label: "RTGS Payee", Type: "Non-Numeric", Short_Name: "RTGS Pay", isChecked: false },
      { Field_Name: "Cheque_Positions", Label: "Cheque Positions", isInputTypeTextArea: true, value: "", SortingOrder: 9 },
    ],
    GRAY_JOB_ISSUE: [
      // { Field_Name: "Taka_No", Type: "Non-Numeric", Short_Name: "No", isChecked: false },
      { Field_Name: "Taka_No", Label: "Taka/Crtn No", Type: "Non-Numeric", Short_Name: "No", Label_Font_Size: 8, Width: 18, Align: 'left', isChecked: false, SortingOrder: 1 },
      { Field_Name: "Meter", Label: "Meter", Type: "Numeric", Short_Name: "Mtr", Label_Font_Size: 8, Width: 12, Align: 'right', isChecked: false, SortingOrder: 2 },
      { Field_Name: "Weight", Label: "Weight", Type: "Non-Numeric", Short_Name: "Wgt", Label_Font_Size: 8, Width: 12, Align: 'right', isChecked: false, SortingOrder: 3 },
      // { Field_Name: "G_Weight", Label: "G.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "GWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 4 },
      // { Field_Name: "T_Weight", Label: "T.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "TWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 5 },
      // { Field_Name: "Net_Weight", Label: "Net.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "NtWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 6 },
      // { Field_Name: "Cheese", Label: "Cheese", Type: "Numeric", Decimal_Place: 0, Short_Name: "Ch", Label_Font_Size: 8, Width: 11, Align: 'center', isChecked: false, SortingOrder: 7 },
      { Field_Name: "Pallu", Label: "Pallu", Type: "Numeric", Decimal_Place: 3, Short_Name: "Plu", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 8 },
      // { Field_Name: "Twist", Label: "Twist", Type: "String", Short_Name: "Twst", Label_Font_Size: 8, Width: 8, Align: 'center', isChecked: false, SortingOrder: 9 },
      { Field_Name: "Quality", Label: "Quality", Type: "String", Short_Name: "Itm", Label_Font_Size: 8, Width: 35, Align: 'left', isChecked: false, SortingOrder: 10 },
      // { Field_Name: "Design_Id", Label: "Design", Type: "String", Short_Name: "Dgn", Label_Font_Size: 8, Width: 25, Align: 'left', isChecked: false, SortingOrder: 11 },
      // { Field_Name: "Remark", Label: "Remark", Type: "String", Short_Name: "Rmk", Label_Font_Size: 8, Width: 20, Align: 'left', isChecked: false, SortingOrder: 12 },
    ],
    JOB_ISSUE: [
      { Field_Name: "Taka_No", Label: "Taka/Crtn No", Type: "Non-Numeric", Short_Name: "No", Label_Font_Size: 8, Width: 18, Align: 'left', isChecked: false, SortingOrder: 1 },
      { Field_Name: "Meter", Label: "Meter", Type: "Numeric", Short_Name: "Mtr", Label_Font_Size: 8, Width: 12, Align: 'right', isChecked: false, SortingOrder: 2 },
      { Field_Name: "Weight", Label: "Weight", Type: "Numeric", Short_Name: "Wgt", Label_Font_Size: 8, Width: 12, Align: 'right', isChecked: false, SortingOrder: 3 },
      { Field_Name: "G_Weight", Label: "G.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "GWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 4 },
      { Field_Name: "T_Weight", Label: "T.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "TWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 5 },
      { Field_Name: "Net_Weight", Label: "Net.Weight", Type: "Numeric", Decimal_Place: 3, Short_Name: "NtWgt", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 6 },
      { Field_Name: "Cheese", Label: "Cheese", Type: "Numeric", Decimal_Place: 0, Short_Name: "Ch", Label_Font_Size: 8, Width: 11, Align: 'center', isChecked: false, SortingOrder: 7 },
      { Field_Name: "Pallu", Label: "Pallu", Type: "Numeric", Decimal_Place: 3, Short_Name: "Plu", Label_Font_Size: 8, Width: 17, Align: 'right', isChecked: false, SortingOrder: 8 },
      { Field_Name: "Twist", Label: "Twist", Type: "String", Short_Name: "Twst", Label_Font_Size: 8, Width: 8, Align: 'center', isChecked: false, SortingOrder: 9 },
      { Field_Name: "Quality", Label: "Quality", Type: "String", Short_Name: "Itm", Label_Font_Size: 8, Width: 35, Align: 'left', isChecked: false, SortingOrder: 10 },
      { Field_Name: "Design_Id", Label: "Design", Type: "String", Short_Name: "Dgn", Label_Font_Size: 8, Width: 25, Align: 'left', isChecked: false, SortingOrder: 11 },
      { Field_Name: "Remark", Label: "Remark", Type: "String", Short_Name: "Rmk", Label_Font_Size: 8, Width: 20, Align: 'left', isChecked: false, SortingOrder: 12 },
    ],
    YARN_BEAM_ISSUE: [
      // { Field_Name: "Taka_No", Type: "Non-Numeric", Short_Name: "No", isChecked: false },
    ],
    EMB_DISPATCH: [
      // { Field_Name: "Taka_No", Type: "Non-Numeric", Short_Name: "No", isChecked: false },
    ],
    DELIVERY_CHALLAN_TRADING: [
      // { Field_Name: "Taka_No", Type: "Non-Numeric", Short_Name: "No", isChecked: false },
    ],  
    PACKING_SLIP: [
      { Field_Name: "2x4", Label: "2x4", IndustryType: "yarn", Short_Name: "2x4", Size_Height: '50.8', Size_Width: '101.6', isChecked: false, SortingOrder: 1 },
      { Field_Name: "4x4", Label: "4x4", IndustryType: "yarn", Short_Name: "4x4", Size_Height: '101.6', Size_Width: '101.6', isChecked: false, SortingOrder: 2 },
      { Field_Name: "6x4", Label: "6x4", IndustryType: "yarn", Short_Name: "6x4", Size_Height: '152.4', Size_Width: '101.6', isChecked: false, SortingOrder: 3 },
    
      { Field_Name: "4x2", Label: "4x2", IndustryType: "gray", Short_Name: "4x2", Size_Height: '101.6', Size_Width: '50.8', isChecked: false, SortingOrder: 4 },
      { Field_Name: "6x2", Label: "6x2", IndustryType: "gray", Short_Name: "6x2", Size_Height: '152.4', Size_Width: '50.8', isChecked: false, SortingOrder: 5 },
    ],
  };

export const MachineType = {
  Looms: 'Looms',
  WaterJet: 'Water Jet',
  Jacquard: 'Jacquard'
}
export const MachineTypes = [MachineType.Looms, MachineType.WaterJet, MachineType.Jacquard];

export const BalanceType = {
  DEBIT: 'Debit',
  CREDIT: 'Credit'
}
export const CollectionStatus = {
  APPROVED: 'Approved',
}
export const BalanceTypes = [BalanceType.DEBIT, BalanceType.CREDIT]

export const MailEncryptionTypes = [
  { label: 'TLS', value: 'tls' },
  { label: 'SSL', value: 'ssl' },
];

export const ImportChallanFormat = [
  { label: 'Format 1', value: 'format1' },
  { label: 'Format 2', value: 'format2' },
  { label: 'Format 3', value: 'format3' },
  { label: 'Format 4', value: 'format4' },
];

export const AccountItemType = {
  Item: 'Item',
  Account: 'Account',
}

export const TABLES = {
    Accounts: 'Accounts',
    Addresses: 'Addresses',
    OpeningBalances: 'OpeningBalances',
    OpeningItemStocks: 'OpeningItemStocks',
    Items: 'Items',
    Wraps: 'Wraps',
    Wefts: 'Wefts',
    Books: 'Books',
    GeneralSettings: 'GeneralSettings',
}
